import {Box, Typography} from '@mui/material';
import './ArrSearchProgressDialog.scss';
import ArrModal, {ArrModalProps} from '../arr-modal/ArrModal';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import {ArrDashedProgressBar} from '../arr-dashed-progressbar/ArrDashedProgressBar';

export interface ArrSearchProgressDialogProps {
  showModal: boolean;
  title: string;
  description: string;
  buttons: ArrModalProps['buttons'];
  className?: string;
  onClose: () => void;
}

const ArrSearchProgressDialog = ({
  showModal,
  title,
  description,
  buttons,
  className,
  onClose,
}: ArrSearchProgressDialogProps) => {
  return (
    <ArrModal
      className={`search-porgress-dialog ${className}`}
      showModal={showModal}
      showClose={false}
      buttons={buttons}
      onClose={onClose}
      dataTestId="search-progress-dialog-modal"
    >
      <Box className={'search-progress-header'}>
        <Box className="search-progress-bar-container">
          <div
            className="pulse-outer-container"
            data-testid={`arr-search-progress-dialog-div`}
          >
            <div
              className="pulse"
              data-testid={`arr-search-progress-dialog-div-btn`}
            ></div>
            <div
              className="container"
              data-testid={`arr-search-progress-dialog-div-button`}
            >
              <SearchOutlinedIcon className="search-color" />
            </div>
          </div>
          <Box className={'dashed-progress-container'}>
            <ArrDashedProgressBar totalSegments={24} intervalTime={30} />
          </Box>
        </Box>
        <Box className={'search-progress-header-context'}>
          <Typography
            className="typo-text headline2_size title-text-color"
            data-testid={`modal-title`}
            tabIndex={0}
          >
            {title}
          </Typography>
          <Typography
            className="typo-text body2_size desc-text-color"
            data-testid={`modal-description`}
            tabIndex={0}
          >
            {description}
          </Typography>
        </Box>
      </Box>
    </ArrModal>
  );
};

export {ArrSearchProgressDialog};
